import Hash from './_Hash';
import ListCache from './_ListCache';
import Map from './_Map';

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

export default mapCacheClear;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_mapCacheClear.js
// module id = null
// module chunks = 